export default __webpack_public_path__ + "ce1ead1f4322db1105185b1110f8fcf8.svg";